import {
  AnalysisParamWithFilter,
  FundAnalysisParam,
  summaryApiParam
} from './types';
import { ANALYSIS, BASE } from '../../utils/service-providers';
import { OrgFundsRequest } from '../fund/types';

function getAnalysisUrl(params: AnalysisParamWithFilter): string {
  const urlParams = new URLSearchParams();

  if (params.pensionSchemeIds?.length) {
    params.pensionSchemeIds.forEach(it => {
      urlParams.append('pensionSchemeIds[]', it);
    });
  }

  if (params.fundIds?.length) {
    params.fundIds.forEach(it => {
      urlParams.append('fundIds[]', it);
    });
  }

  if (params.assetClassIds?.length) {
    params.assetClassIds.forEach(it => {
      urlParams.append('assetClassIds[]', it);
    });
  }

  if (params.assetManagerIds?.length) {
    params.assetManagerIds.forEach(it => {
      urlParams.append('assetManagerIds[]', it);
    });
  }

  if (params.reportingPeriodIds?.length) {
    params.reportingPeriodIds?.forEach(it => {
      urlParams.append('reportingPeriodIds[]', it);
    });
  }

  if (params.subFundIds?.length) {
    params.subFundIds?.forEach(it => {
      urlParams.append('subFundIds[]', it);
    });
  }

  if (params.source) {
    urlParams.set('source', params.source.toString());
  }
  if (params?.status) {
    urlParams.set('status', params.status.toString());
  }
  if (params?.rootOrgId) {
    urlParams.set('rootOrgId', params.rootOrgId.toString());
  }
  if (params?.drilldownLevel) {
    urlParams.set('drilldownLevel', params.drilldownLevel.toString());
  }
  if (params?.responseFilter) {
    const obj: any = params?.responseFilter;
    Object.keys(params?.responseFilter).forEach(key => {
      if (obj[key]) {
        urlParams.append(`responseFilter[]`, key);
      }
    });
  }
  return urlParams.toString();
}

function getFundAnalysisUrl(params: FundAnalysisParam): string {
  const urlParams = new URLSearchParams();

  if (params.pensionSchemeIds?.length) {
    params.pensionSchemeIds.forEach(it => {
      urlParams.append('pensionSchemeIds[]', it);
    });
  }

  if (params.fundIds?.length) {
    params.fundIds.forEach(it => {
      urlParams.append('fundIds[]', it);
    });
  }

  if (params.assetClassIds?.length) {
    params.assetClassIds.forEach(it => {
      urlParams.append('assetClassIds[]', it);
    });
  }

  if (params.assetManagerIds?.length) {
    params.assetManagerIds.forEach(it => {
      urlParams.append('assetManagerIds[]', it);
    });
  }

  if (params.reportingPeriodIds?.length) {
    params.reportingPeriodIds?.forEach(it => {
      urlParams.append('reportingPeriodIds[]', it);
    });
  }

  if (params.subFundIds?.length) {
    params.subFundIds?.forEach(it => {
      urlParams.append('subFundIds[]', it);
    });
  }

  if (params.source) {
    urlParams.set('source', params.source.toString());
  }
  if (params?.status) {
    urlParams.set('status', params.status.toString());
  }
  if (params?.rootOrgId) {
    urlParams.set('rootOrgId', params.rootOrgId.toString());
  }
  if (params?.drilldownLevel) {
    urlParams.set('drilldownLevel', params.drilldownLevel.toString());
  }
  if (params?.page) {
    urlParams.set('page', params.page.toString());
  }
  if (params?.limit) {
    urlParams.set('limit', params.limit.toString());
  }
  return urlParams.toString();
}

export const GET_ANALYSIS_BY_ORG_ID = (params: AnalysisParamWithFilter) => {
  const urlString = getAnalysisUrl(params);
  return `${ANALYSIS}/reporting/all?` + urlString;
};

export const GET_FUND_ANALYSIS = (params: FundAnalysisParam) => {
  const urlString = getFundAnalysisUrl(params);
  return `${ANALYSIS}/reporting/fundAnalysis?` + urlString;
};

export const FETCH_COST_SUMMARY = (params: summaryApiParam) => {
  const urlParams = new URLSearchParams();

  if (params.investmentId?.length) {
    params.investmentId.forEach(it => {
      urlParams.append('id[]', it);
    });
  }
  if (params?.fundIds?.length) {
    params.fundIds.forEach(it => {
      urlParams.append('fundIds[]', it);
    });
  }
  if (params?.submissionIds?.length) {
    params.submissionIds.forEach(it => {
      urlParams.append('submissionIds[]', it);
    });
  }
  if (params.source) {
    urlParams.set('source', params.source.toString());
  }
  if (params?.rootOrgId) {
    urlParams.set('rootOrgId', params.rootOrgId.toString());
  }
  if (params?.drilldownLevel) {
    urlParams.set('drilldownLevel', params.drilldownLevel.toString());
  }
  return `${ANALYSIS}/reporting/summary?` + urlParams.toString();
};

const getOrgFundsRequestString = (
  orgFundsRequest: OrgFundsRequest,
  includes?: string
) => {
  const params = new URLSearchParams();

  if (orgFundsRequest?.page) {
    params.set('page', orgFundsRequest.page.toString());
  }
  if (orgFundsRequest?.limit) {
    params.set('limit', orgFundsRequest.limit.toString());
  }
  if (orgFundsRequest?.status) {
    params.set('status', orgFundsRequest.status.toString());
  }
  if (orgFundsRequest.rootIds?.length) {
    orgFundsRequest.rootIds?.forEach(it => {
      params.append('filter[parent_id][]', it);
    });
  }
  if (orgFundsRequest.reportingPeriodIds?.length) {
    orgFundsRequest.reportingPeriodIds?.forEach(it => {
      params.append('filter[entity.timePeriodId][]', it);
    });
  }
  if (orgFundsRequest.assetManagerIds?.length) {
    orgFundsRequest.assetManagerIds?.forEach(it => {
      params.append('filter[entity.managerOrgId][]', it);
    });
  }
  if (orgFundsRequest.assetClassIds?.length) {
    orgFundsRequest.assetClassIds?.forEach(it => {
      params.append('filter[entity.productTypeId][]', it);
    });
  }
  if (orgFundsRequest.fundIds?.length) {
    orgFundsRequest.fundIds?.forEach(it => {
      params.append('filter[id][]', it);
    });
  }
  if (orgFundsRequest.searchKeyword) {
    params.set('filter[entity.name]', orgFundsRequest.searchKeyword);
  }
  if (includes) {
    params.set('include', includes);
  }
  return params.toString();
};

export const GET_ALL_FUNDS_BY_FILTER = (orgFundsRequest: OrgFundsRequest) => {
  const includes =
    `entity,timePeriod,submissionRequest,parent,latestSubmission,` +
    `entity.nature,entity.strategy,entity.assetManager,entity.productType,` +
    `parent.entity`;
  const urlString = getOrgFundsRequestString(orgFundsRequest, includes);
  return (
    `/base/organizations/${orgFundsRequest.orgId}/investments/all-funds?` +
    `${urlString}`
  );
};

export const GET_ALL_ASSET_CLASSES = (params: any) => {
  return `${BASE}/product-types`;
};

export const GET_ALL_ORGANISATIONS = (params: any) => {
  // tslint:disable-next-line:max-line-length
  return (
    `${BASE}/organizations?include=organizationType,` +
    `parentOrganization,childOrganizations,users,clients,providers`
  );
};

export const GET_ORGANISATION_WITH_CHILDREN = (params: any) => {
  // tslint:disable-next-line:max-line-length
  return (
    `${BASE}/organizations/${params.id}?include=organizationType,owner,parentOrganization,childOrganizations,users,` +
    `clients,providers,childOrganizations.rootInvestments,childOrganizations.rootInvestments.timePeriod`
  );
};

export const GET_ALL_FUNDS_BY_ORGANISATION_ID = (params: any) => {
  return `${BASE}/organizations/${params.id}/funds`;
};

export const GET_ALL_TIME_PERIODS = (params: any) => {
  return `${BASE}/time-periods`;
};

export const GET_ALL_ORGANISATION_TYPES = `${BASE}/organization-types`;

export const GET_ALL_INVESTMENTS =
  `${BASE}/investments?include=entity,timePeriod,` +
  `children,children.entity,children.timePeriod,parent,parent.entity,parent.timePeriod,` +
  `rootInvestment,rootInvestment.entity,rootInvestment.timePeriod,children.latestSubmission&limit=-1`;

export const GET_EXPOSED_ORGANIZATION_FUNDS = (orgId: string) => {
  return `/base/organizations/${orgId}/investments/funds?status=exposed`;
};

export const GET_EXPOSED_PENSION_SCHEMES = (orgId: string) => {
  return `/base/organizations/${orgId}/pension-schemes?status=exposed`;
};

export const GET_ORGANISATION_MANAGERS = (orgId: string) => {
  return `/base/organizations/${orgId}/providers/managers`;
};
